import { render } from "./SettingsDatatableFormClientSourceTitle.vue?vue&type=template&id=4c0b78b6"
import script from "./SettingsDatatableFormClientSourceTitle.vue?vue&type=script&lang=js"
export * from "./SettingsDatatableFormClientSourceTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__